import React, { useEffect, useRef } from 'react';
import useClickOutside from '../../../../../ui-kit/Header/ClickOutsideToClose'

const DropdownHandler = ({
    values,
    setFieldValue,
    setDropdownMembersOpen,
    dropdownMembersOpen,
    children,
  }: {
    values: any;
    setFieldValue: any;
    setDropdownMembersOpen: (open: boolean) => void;
    children: React.ReactNode;
    dropdownMembersOpen: boolean;
  }) => {
    const dropdownRef = useRef<HTMLDivElement>(null);
  
    useClickOutside(dropdownRef, () => {
      handleCancelDropdown(values, setFieldValue, setDropdownMembersOpen);
    });

    const handleCancelDropdown = (values: any, setFieldValue: any, setDropdownMembersOpen: (open: boolean) => void) => {
      const memberAccesses = values?.memberEdit || {};
      const filteredAccesses = {
        users: [
          ...values.membersUsers.filter((id: any) => memberAccesses.users?.includes(id)), // Matched IDs
          ...memberAccesses.users?.filter((id: any) => !values.membersUsers.includes(id)) || [] // Unmatched IDs added back
        ],
        jobTitles: [
          ...values.membersJob_titles.filter((id: any) => memberAccesses.jobTitles?.includes(id)),
          ...memberAccesses.jobTitles?.filter((id: any) => !values.membersJob_titles.includes(id)) || []
        ],
        projectGroups: [
          ...values.membersProject_groups.filter((id: any) => memberAccesses.projectGroups?.includes(id)),
          ...memberAccesses.projectGroups?.filter((id: any) => !values.membersProject_groups.includes(id)) || []
        ],
        departments: [
          ...values.membersDepartments.filter((id: any) => memberAccesses.departments?.includes(id)),
          ...memberAccesses.departments?.filter((id: any) => !values.membersDepartments.includes(id)) || []
        ],
        offices: [
          ...values.membersOffices.filter((id: any) => memberAccesses.offices?.includes(id)),
          ...memberAccesses.offices?.filter((id: any) => !values.membersOffices.includes(id)) || []
        ],
        roles: [
          ...values.membersRoles.filter((id: any) => memberAccesses.roles?.includes(id)),
          ...memberAccesses.roles?.filter((id: any) => !values.membersRoles.includes(id)) || []
        ],
      };
      
      setFieldValue('membersUsers', filteredAccesses.users);
      setFieldValue('membersJob_titles', filteredAccesses.jobTitles);
      setFieldValue('membersProject_groups', filteredAccesses.projectGroups);
      setFieldValue('membersDepartments', filteredAccesses.departments);
      setFieldValue('membersOffices', filteredAccesses.offices);
      setFieldValue('membersRoles', filteredAccesses.roles);
    
      setDropdownMembersOpen(false);
  };
  
    return (
      <div
        ref={dropdownRef}
        style={{
          position: 'absolute',
          top: 0,
          zIndex: 10001,
          backgroundColor: 'white',
          borderRadius: 8,
          padding: 25,
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
          width: '25rem',
        }}
      >
        {children}
      </div>
    );
};
  
export default DropdownHandler;